import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'
import { Button } from 'components/shared/Button/Button'
import cx from 'classnames'
import { useInvitesTable } from './hooks'
import { getActions } from './helpers'

import styles from './InvitesTable.module.scss'
import { CandidateCell } from 'components/shared/Table/common/Cells/CandidateCell/CandidateCell'
import { PhoneCell } from 'components/shared/Table/common/Cells/PhoneCell/PhoneCell'
import { LanguageCell } from 'components/shared/Table/common/Cells/LanguageCell/LanguageCell'
import { JobProgressCell } from 'components/shared/Table/common/Cells/JobProgressCell/JobProgressCell'

export const InvitesTable = ({
  search,
  handleCopy,
  handleDelete,
  handleEdit,
  onSendTestsMessage,
}) => {
  const { state, handlers } = useInvitesTable({ search })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: {
      headers,
      model,
      rowActions,
      isFetching,
      rowSelection,
      isAllRowsSelected,
      isSomeRowsSelected,
    },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
    table: { toggleAllRowsSelectedHandler },
  } = handlers

  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row
            type="head"
            onChange={toggleAllRowsSelectedHandler}
            isChecked={isAllRowsSelected}
            isIndeterminate={isSomeRowsSelected}
            hasCheckbox
            hide={isFetching}
          >
            {R.map(({ columnDef, getToggleSortingHandler, getIsSorted }) => {
              const { accessorKey, header, alignLeft } = columnDef

              return (
                <HeaderCell
                  key={header}
                  alignLeft={!!alignLeft}
                  sortType={getIsSorted()}
                  text={header}
                  onClick={getToggleSortingHandler()}
                  hasSorting={accessorKey}
                />
              )
            }, headers)}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{
            title: t`No results yet`,
            text: t`Try adjusting your search`,
          }}
          isLoaded={R.not(isFetching)}
        >
          {R.map(
            ({
              id,
              original,
              getIsSelected,
              getIsSomeSelected,
              getToggleSelectedHandler,
            }) => {
              if (!original?.timestamps?.created) {
                return null
              }
              const actions = getActions(
                { actions: rowActions, jobSeeker: original },
                { handleCopy, handleDelete, handleEdit },
              ).filter(action => action.type !== 'ACTION_COPY')

              const {
                email,
                language,
                name,
                phone,
                selection_stage,
                status,
              } = original

              return (
                <Table.Row
                  key={id}
                  type="body"
                  onChange={getToggleSelectedHandler()}
                  isChecked={getIsSelected()}
                  isIndeterminate={getIsSomeSelected()}
                  isSelected={rowSelection[id]}
                  hasCheckbox
                >
                  <CandidateCell email={email} name={name} indentIcon />
                  <PhoneCell phone={phone} />
                  <LanguageCell language={language} />
                  <JobProgressCell
                    progress={selection_stage - 1}
                    hasInterviewModule={false}
                    status={status}
                    type="candidate"
                  />
                  <ActionsCell className={styles.actionsCell}>
                    <Button
                      className={cx(styles.button, styles.sendInviteButton)}
                      color="primary"
                      label={t`Send invite`}
                      size="small"
                      variant="filled"
                      onClick={() =>
                        onSendTestsMessage({ candidate: original })
                      }
                    />
                    <ActionsDropdown size="medium" {...{ actions }} />
                  </ActionsCell>
                </Table.Row>
              )
            },
            model.rows,
          )}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
